import {
  ACTION_TO_FAVORITE,
  APPLICANT_COMPANY_INTERVIEW,
  APPLICANT_INTERVIEW_STATUS,
  CHANGE_LANGUAGE,
  CHECK_AUTHENTICATED,
  CHECK_EMAIL_ERROR,
  CHECK_EMAIL_SUCCESS,
  CHECK_IN_ERROR,
  CHECK_IN_SUCCESS,
  CHECK_UNAUTHORIZED,
  CHECK_UNAUTHORIZED_RECEPTIONIST,
  CLEAR_CHECK_IN_DATA,
  CLEAR_REGISTER_DATA,
  COMPANY_DETAIL,
  CONFIRM_MAIL_ERROR,
  CONFIRM_MAIL_ERROR_RESET,
  CONFIRM_MAIL_SUCCESS,
  EVENT_ERROR,
  EVENT_INTERVIEW_NOTE,
  EVENT_SUCCESS,
  GET_CONSTANTS,
  GET_DATA_EVENT_SCHEDULE_SUCCESS,
  GET_EVENT_MASTER,
  GET_LANG,
  GET_LIST_COMPANY,
  LANDING_PAGE_LINK_SUCCESS,
  LIST_CHECK_IN_ERROR,
  LIST_CHECK_IN_SUCCESS,
  LOGIN_ERROR,
  LOGIN_ERROR_RECEPTIONIST,
  LOGIN_SUCCESS,
  LOGIN_SUCCESS_RECEPTIONIST,
  LOGOUT,
  LOGOUT_RECEPTIONIST,
  ME_ERROR,
  ME_ERROR_RECEPTIONIST,
  ME_SUCCESS,
  ME_SUCCESS_RECEPTIONIST,
  PREVIEW_COMPANY_ERROR,
  PREVIEW_COMPANY_SUCCESS,
  REGISTER_ERROR,
  REGISTER_SUCCESS,
  RESET_REGISTER_STATUS,
  SET_AUTHENTICATED,
  SET_CONTRACT_EVENT,
  SET_DOMAIN,
  SET_EVENT_SCHEDULE_SUCCESS,
  SET_REGISTRATION_PERIOD_STATUS,
  SET_TOKEN_FOR_RECEPTIONIST,
  STEP_ONE_STORAGE,
  STEP_TWO_STORAGE,
  UPDATE_DISPLAY_FLAG_INFO_LOG_SUCCESS,
  UPDATE_DISPLAY_FLAG_NOTIFICATION_APPLICANT_SUCCESS,
  UPDATE_ENTRY_INFORMATION_ERROR,
  UPDATE_ENTRY_INFORMATION_SUCCESS,
  UPDATE_INFORMATION_ERROR,
  UPDATE_INFORMATION_SUCCESS,
  UPDATE_READ_FLAG_INFO_LOG_SUCCESS,
  UPDATE_READ_FLAG_NOTIFICATION_APPLICANT_SUCCESS,
  UPDATE_SCOUT_MAIL_VIEWED_SUCCESS
} from './mutation-types';

import {
  DOMAIN_NAME,
  LANG_CODE_JAPANESE,
  LANG_CODE_VIETNAMESE,
  LANG_JAPANESE_TITLE,
  LANG_VIETNAMESE_TITLE,
  RESPONSE_STATUS_UNAUTHORIZED
} from '@/common/constants';

import { getObjFromLS, setKeyNameLS } from '@/common';

const mutations = {
  [EVENT_SUCCESS](state, payload) {
    const { event_code, contract_id, event_day_register_url_code } =
      payload.data;
    const fullPath = payload.fullPath;

    const checkEvent = {
      event_code,
      event_id: state.eventMaster.m_event.id,
      contract_id,
      event_day_register_url_code,
      register_status: payload.registerStatus,
      success: true
    };

    const keyStore = checkEvent.contract_id + checkEvent.event_code;

    let token = null;
    let token_rc = null;

    let sekisho_lang = LANG_CODE_JAPANESE;

    const langActive = state.dataLanguage.filter(
      (lang) => lang.id === state.defaultLanguage
    );

    sekisho_lang =
      langActive.length > 0 ? langActive[0].lang_code : LANG_CODE_JAPANESE;

    const objFromLS =
      localStorage.getItem(keyStore) !== null
        ? JSON.parse(localStorage.getItem(keyStore))
        : null;

    if (objFromLS !== null && typeof objFromLS !== 'undefined') {
      token = objFromLS.token || null;
    }

    if (objFromLS !== null && typeof objFromLS !== 'undefined') {
      token_rc = objFromLS.token_rc;
    }

    if (objFromLS !== null && typeof objFromLS.sekisho_lang !== 'undefined') {
      sekisho_lang = objFromLS.sekisho_lang;
    }

    const dataKeyStore = {
      event: checkEvent,
      token: token,
      token_rc: token_rc,
      sekisho_lang: payload.queryLang || sekisho_lang
    };

    localStorage.setItem(keyStore, JSON.stringify(dataKeyStore));

    return [
      (state.checkEvent = Object.assign({}, checkEvent)),
      (state.contract_id = contract_id),
      (state.event_code = event_code),
      (state.fullPath = fullPath),
      (state.eventSuccess = true)
    ];
  },

  [EVENT_ERROR](state) {
    localStorage.removeItem(setKeyNameLS(state));

    const checkEvent = {
      event_id: null,
      event_code: null,
      contract_id: null,
      success: false
    };
    return [(state.checkEvent = Object.assign({}, checkEvent))];
  },

  [GET_LANG](state) {
    const keyStore = state.contract_id + state.event_code;
    let lang = LANG_CODE_JAPANESE;

    const objFromLS =
      localStorage.getItem(keyStore) !== null
        ? JSON.parse(localStorage.getItem(keyStore))
        : null;

    if (objFromLS !== null && typeof objFromLS.sekisho_lang !== 'undefined') {
      lang = objFromLS.sekisho_lang;
    }

    return (state.lang = lang);
  },

  [CHANGE_LANGUAGE](state, payload) {
    return [(state.lang = payload.lang), (state.langTitle = payload.langTitle)];
  },

  [GET_CONSTANTS](state, payload) {
    return (state.constants = { ...payload.data });
  },

  [GET_EVENT_MASTER](state, payload) {
    const { template, m_event } = payload.data;

    const { c_language } = state.constants;
    let languageSupported = [];
    if (c_language && template) {
      const { lang_type } = template;

      const langTypeParse = JSON.parse(lang_type);

      languageSupported = c_language.filter(
        (lang) => !!langTypeParse.includes(lang.id)
      );

      languageSupported.map((lang) => {
        if (lang.lang_code === LANG_CODE_JAPANESE) {
          return Object.assign(lang, { lang_name: LANG_JAPANESE_TITLE });
        } else if (lang.lang_code === LANG_CODE_VIETNAMESE) {
          return Object.assign(lang, { lang_name: LANG_VIETNAMESE_TITLE });
        } else {
          return lang;
        }
      });
    }

    return (
      (state.eventMaster = { ...payload.data }),
      (state.registrationPeriodStatus = payload.registrationPeriodStatus),
      (state.dataLanguage = languageSupported || []),
      (state.defaultLanguage = m_event.default_lang || 1)
    );
  },

  [STEP_ONE_STORAGE](state, payload) {
    const registerData =
      localStorage.getItem('registerData') !== null
        ? localStorage.getItem('registerData')
        : null;

    let stepTwo = null;
    if (registerData !== null) {
      stepTwo = JSON.parse(registerData).stepTwo;
    }

    const stepOneNew = {
      ...payload.data
    };

    const registerDataNew = {
      stepOne: stepOneNew,
      stepTwo: typeof stepTwo !== 'undefined' ? stepTwo : {}
    };

    localStorage.setItem('registerData', JSON.stringify(registerDataNew));

    return (state.registerData = Object.assign({}, registerDataNew));
  },

  [STEP_TWO_STORAGE](state, payload) {
    const registerData =
      localStorage.getItem('registerData') !== null
        ? localStorage.getItem('registerData')
        : null;

    let stepOne = null;
    if (registerData !== null) {
      stepOne = JSON.parse(registerData).stepOne;
    }

    const stepTwoNew = {
      ...payload.data
    };

    const registerDataNew = {
      stepOne: typeof stepOne !== 'undefined' ? stepOne : {},
      stepTwo: stepTwoNew
    };

    localStorage.setItem('registerData', JSON.stringify(registerDataNew));

    return (state.registerData = Object.assign({}, registerDataNew));
  },

  [LOGIN_SUCCESS](state, payload) {
    const nameKeyLS = setKeyNameLS(state);
    const objFromLS = getObjFromLS(state);

    objFromLS.token = payload.token;

    localStorage.setItem(nameKeyLS, JSON.stringify(objFromLS));

    const checkAuth = {
      isAuthenticated: true
    };

    const profile = {
      ...payload.profile
    };

    return [
      (state.checkAuth = Object.assign({}, checkAuth)),
      (state.profile = Object.assign({}, profile))
    ];
  },

  [LOGIN_ERROR](state) {
    const checkAuth = {
      isAuthenticated: false
    };

    return (state.checkAuth = Object.assign({}, checkAuth));
  },

  [REGISTER_SUCCESS](state, payload) {
    const registerResult = payload.data;

    return (
      (state.registerStatus = true),
      (state.registerResult = Object.assign({}, registerResult))
    );
  },

  [REGISTER_ERROR](state) {
    return (state.registerStatus = false);
  },

  [RESET_REGISTER_STATUS](state) {
    return [(state.registerStatus = null), (state.registerResult = null)];
  },

  [SET_AUTHENTICATED](state) {
    const checkAuth = {
      isAuthenticated: true
    };

    return (state.checkAuth = Object.assign({}, checkAuth));
  },

  [CHECK_AUTHENTICATED](state) {
    let isAuthenticated = false;
    const key = state.contract_id + state.event_code;

    const objFromLS =
      localStorage.getItem(key) !== null
        ? JSON.parse(localStorage.getItem(key))
        : null;

    if (objFromLS !== null && typeof objFromLS !== 'undefined') {
      isAuthenticated = objFromLS.token !== null;
    }

    const checkAuth = {
      ...state.checkAuth,
      isAuthenticated
    };

    return (state.checkAuth = Object.assign({}, checkAuth));
  },

  [LOGOUT](state) {
    const key = state.contract_id + state.event_code;
    const event =
      localStorage.getItem(key) !== null
        ? JSON.parse(localStorage.getItem(key))
        : null;

    const data = {
      ...event,
      token: null
    };

    if (event) {
      localStorage.setItem(key, JSON.stringify(data));
    }

    const checkAuth = {
      isAuthenticated: false
    };

    return (state.checkAuth = Object.assign({}, checkAuth));
  },

  [GET_LIST_COMPANY](state, payload) {
    return (state.company = Object.assign({}, { ...payload.data }));
  },

  [ACTION_TO_FAVORITE](state, payload) {
    return (state.company = Object.assign({}, { ...payload.data }));
  },

  [COMPANY_DETAIL](state, payload) {
    return (state.companyDetail = payload.data);
  },

  [PREVIEW_COMPANY_SUCCESS](state) {
    return (state.previewCompanyStatus = true);
  },
  [PREVIEW_COMPANY_ERROR](state) {
    return (state.previewCompanyStatus = false);
  },

  [ME_SUCCESS](state, payload) {
    const profile = {
      applicant: payload.data.d_applicant,
      applicant_entry: payload.data.d_applicant_entry.data,

      information: payload.data.information,
      notification: payload.data.notification,
      data_notification: payload.data.data_notification,
      scout_mail: payload.data.scout_mail,
      noti: payload.data.noti
    };
    return (state.profile = Object.assign({}, profile));
  },

  [ME_ERROR](state) {
    return (state.profile = null);
  },

  [UPDATE_INFORMATION_SUCCESS](state, payload) {
    const profile = {
      applicant: {
        data: Object.assign({ ...state.profile.applicant }, { ...payload.data })
      },
      applicant_entry: Object.assign({}, { ...state.profile.applicant_entry })
    };

    return (
      (state.profile = Object.assign({}, profile)),
      (state.updateBasicInformationStatus = true)
    );
  },

  [UPDATE_INFORMATION_ERROR](state) {
    return (state.updateBasicInformationStatus = false);
  },

  [UPDATE_ENTRY_INFORMATION_SUCCESS](state, payload) {
    const profile = {
      applicant_entry: Object.assign(
        { ...state.profile.applicant_entry },
        { ...payload.data }
      ),
      applicant: Object.assign({}, { ...state.profile.applicant })
    };

    return (
      (state.profile = Object.assign({}, profile)),
      (state.updateEntryInformationStatus = true)
    );
  },

  [UPDATE_ENTRY_INFORMATION_ERROR](state) {
    return (state.updateEntryInformationStatus = false);
  },

  [CHECK_UNAUTHORIZED](state, { err }) {
    if (
      err &&
      err.response &&
      err.response.status == RESPONSE_STATUS_UNAUTHORIZED
    ) {
      const keyStore = state.contract_id + state.event_code;

      let sekisho_lang = LANG_CODE_JAPANESE;

      const langActive = state.dataLanguage.filter(
        (lang) => lang.id === state.defaultLanguage
      );

      sekisho_lang =
        langActive.length > 0 ? langActive[0].lang_code : LANG_CODE_JAPANESE;

      const objFromLS =
        localStorage.getItem(keyStore) !== null
          ? JSON.parse(localStorage.getItem(keyStore))
          : null;

      const dataKeyStore = {
        ...objFromLS,
        token: null,
        sekisho_lang: sekisho_lang
      };

      localStorage.setItem(keyStore, JSON.stringify(dataKeyStore));

      return (state.checkAuth = { ...state.checkAuth, isUnauthorized: true });
    }

    return (state.checkAuth = Object.assign(
      { ...state.checkAuth },
      { isUnauthorized: null }
    ));
  },

  [CHECK_UNAUTHORIZED_RECEPTIONIST](state, { err }) {
    if (
      err &&
      err.response &&
      err.response.status == RESPONSE_STATUS_UNAUTHORIZED
    ) {
      const keyStore = state.contract_id + state.event_code;

      const dataKeyStore = {
        event: state.checkEvent,
        token: null,
        token_rc: null,
        sekisho_lang: 'jp-en'
      };

      localStorage.setItem(keyStore, JSON.stringify(dataKeyStore));

      return (state.checkAuthReceptionist = {
        ...state.checkAuthReceptionist,
        isUnauthorized: true
      });
    }

    return (state.checkAuth = Object.assign(
      { ...state.checkAuth },
      { isUnauthorized: null }
    ));
  },

  [CONFIRM_MAIL_SUCCESS](state, payload) {
    const registerResult = payload.data.applicant;
    if (typeof registerResult !== 'undefined') {
      return (
        (state.registerResult = Object.assign({}, registerResult)),
        (state.registerResultStatus = true)
      );
    }

    return { ...state };
  },

  [CONFIRM_MAIL_ERROR](state) {
    return (state.registerResultStatus = false), (state.registerData = null);
  },

  [CONFIRM_MAIL_ERROR_RESET](state) {
    return (state.registerResultStatus = null);
  },

  [UPDATE_SCOUT_MAIL_VIEWED_SUCCESS](state, payload) {
    const scoutMail = Object.assign({}, payload.data);

    const scoutMailArray = state.profile.scout_mail;

    const scoutMailNewArray = scoutMailArray.map((ele) => {
      if (ele.id === scoutMail.id) {
        return Object.assign(ele, scoutMail);
      }
      return ele;
    });

    const profile = {
      ...state.profile,
      scout_mail: scoutMailNewArray
    };

    return {
      ...state,
      profile
    };
  },

  [UPDATE_READ_FLAG_NOTIFICATION_APPLICANT_SUCCESS](state, payload) {
    const notification = Object.assign({}, payload.data);

    const notificationArray = state.profile.notification;

    const notificationNewArray = notificationArray.map((ele) => {
      if (ele.id === notification.id) {
        const obj = {
          ...ele
        };

        obj.read_flag = notification.read_flag;

        return Object.assign(ele, obj);
      }
      return ele;
    });

    const profile = {
      ...state.profile,
      notification: notificationNewArray
    };

    return {
      ...state,
      profile
    };
  },

  [UPDATE_DISPLAY_FLAG_NOTIFICATION_APPLICANT_SUCCESS](state, payload) {
    const notification = Object.assign({}, payload.data);

    const notificationArray = state.profile.notification;

    const notificationNewArray = notificationArray.filter(
      (ele) => ele.id !== notification.id
    );

    const profile = {
      ...state.profile,
      notification: Object.assign([], notificationNewArray)
    };

    return (state.profile = Object.assign({}, profile));
  },

  [SET_DOMAIN](state, payload) {
    console.log(payload);
    console.log(process.env);
    let baseUrl = payload.protocol + '//' + payload.host + '/api/v1';
    if (payload.host.startsWith('localhost')) {
      baseUrl = DOMAIN_NAME + '/api/v1';
    }

    return (state.baseUrl = baseUrl);
  },

  [CHECK_EMAIL_SUCCESS](state) {
    return (state.emailCheck = false);
  },

  [CHECK_EMAIL_ERROR](state) {
    return (state.emailCheck = true);
  },

  [APPLICANT_COMPANY_INTERVIEW](state, payload) {
    return (state.applicantCompanyInterview = payload.data);
  },

  [CLEAR_REGISTER_DATA](state) {
    localStorage.removeItem('registerData');
    return {
      ...state,
      registerData: {
        stepOne: {},
        stepTwo: {}
      },
      registerStatus: null,
      registerResult: null,
      registerResultStatus: null
    };
  },

  [APPLICANT_INTERVIEW_STATUS](state, payload) {
    return (state.applicantInterviewStatus = payload.data);
  },

  [EVENT_INTERVIEW_NOTE](state, payload) {
    return (state.eventInterviewNote = payload.data);
  },

  [LOGIN_SUCCESS_RECEPTIONIST](state, payload) {
    const nameKeyLS = setKeyNameLS(state);
    const objFromLS = getObjFromLS(state);

    objFromLS.token_rc = payload.token;

    localStorage.setItem(nameKeyLS, JSON.stringify(objFromLS));

    const checkAuthReceptionist = {
      ...state.checkAuthReceptionist,
      isAuthenticated: true
    };

    return (state.checkAuthReceptionist = Object.assign(
      {},
      checkAuthReceptionist
    ));
  },

  [LOGIN_ERROR_RECEPTIONIST](state) {
    const checkAuthReceptionist = {
      ...state.checkAuthReceptionist,
      isAuthenticated: false
    };

    return (state.checkAuthReceptionist = Object.assign(
      {},
      checkAuthReceptionist
    ));
  },

  [LOGOUT_RECEPTIONIST](state) {
    const key = state.contract_id + state.event_code;
    const event =
      localStorage.getItem(key) !== null
        ? JSON.parse(localStorage.getItem(key))
        : null;

    const data = {
      ...event,
      token_rc: null
    };

    if (event) {
      localStorage.setItem(key, JSON.stringify(data));
    }

    const checkAuthReceptionist = {
      isAuthenticated: false
    };

    return (state.checkAuthReceptionist = Object.assign(
      {},
      checkAuthReceptionist
    ));
  },

  [SET_TOKEN_FOR_RECEPTIONIST](state) {
    const checkAuthReceptionist = {
      isAuthenticated: true
    };

    return (state.checkAuthReceptionist = Object.assign(
      {},
      checkAuthReceptionist
    ));
  },

  [UPDATE_READ_FLAG_INFO_LOG_SUCCESS](state, payload) {
    const infoLog = payload.data[0];

    if (typeof infoLog !== 'undefined') {
      const { information } = state.profile;

      if (typeof information !== 'undefined') {
        const informationFiltered = information.d_info.filter(
          (ele) => ele.id == infoLog.info_id
        );

        const unreadNoticeFiltered = information.unread_notice.filter(
          (ele) => ele.id !== infoLog.info_id
        );

        if (informationFiltered.length > 0) {
          const { info_has_been_read = [] } = information;

          info_has_been_read.push(informationFiltered[0]);

          const newInformation = {
            ...information,
            info_has_been_read: Object.assign([], info_has_been_read),
            unread_notice: Object.assign([], unreadNoticeFiltered)
          };

          const profile = {
            ...state.profile,
            information: Object.assign({}, newInformation)
          };

          return (state.profile = Object.assign({}, profile));
        }
      }
    }
    return { ...state };
  },

  [UPDATE_DISPLAY_FLAG_INFO_LOG_SUCCESS](state, payload) {
    const infoLog = payload.data[0];

    if (typeof infoLog !== 'undefined') {
      const { information } = state.profile;

      const informationFiltered = information.d_info.filter(
        (ele) => ele.id == infoLog.info_id
      );

      const unreadNoticeFiltered = information.unread_notice.filter(
        (ele) => ele.id !== infoLog.info_id
      );

      if (informationFiltered.length > 0) {
        const { hidden_info = [] } = information;

        hidden_info.push(informationFiltered[0]);

        const newInformation = {
          ...information,
          hidden_info: Object.assign([], hidden_info),
          unread_notice: Object.assign([], unreadNoticeFiltered)
        };

        const profile = {
          ...state.profile,
          information: Object.assign({}, newInformation)
        };

        return (state.profile = Object.assign({}, profile));
      }
    }
    return { ...state };
  },

  [ME_SUCCESS_RECEPTIONIST](state, payload) {
    const meReceptionist = {
      applicant: payload.data.d_applicant,
      applicant_entry: payload.data.d_applicant_entry.data,

      information: payload.data.information,
      notification: payload.data.notification,
      data_notification: payload.data.data_notification,
      scout_mail: payload.data.scout_mail
    };
    return (state.meReceptionist = Object.assign({}, meReceptionist));
  },

  [ME_ERROR_RECEPTIONIST](state) {
    return (state.meReceptionist = null);
  },

  [CHECK_IN_SUCCESS](state, payload) {
    const checkInData = payload.data;

    return (state.checkInData = Object.assign({}, checkInData));
  },

  [CHECK_IN_ERROR](state) {
    return (state.checkInData = null);
  },

  [LIST_CHECK_IN_SUCCESS](state, payload) {
    const listCheckInReception = {
      list: payload.data.list,
      amount: payload.data.amount
    };

    return (state.listCheckInReception = Object.assign(
      {},
      listCheckInReception
    ));
  },
  [LANDING_PAGE_LINK_SUCCESS](state, payload) {
    const data = payload.data;
    return (state.landingPageLinkData = Object.assign({}, data));
  },
  [LIST_CHECK_IN_ERROR](state) {
    return (state.listCheckInReception = null);
  },
  [SET_CONTRACT_EVENT](state, payload) {
    return (
      (state.contract_id = payload.contract_id),
      (state.event_code = payload.event_code)
    );
  },

  [CLEAR_CHECK_IN_DATA](state) {
    return (state.checkInData = null);
  },

  [SET_REGISTRATION_PERIOD_STATUS](state, payload) {
    return (state.registrationPeriodStatus = payload.status);
  },

  [GET_DATA_EVENT_SCHEDULE_SUCCESS](state, payload) {
    return (state.dataEventSchedule = Object.assign({}, payload.data));
  },

  [SET_EVENT_SCHEDULE_SUCCESS](state, payload) {
    const dataEventSchedule = {
      ...state.dataEventSchedule,
      eventSchedule: payload.data
    };
    return (state.dataEventSchedule = Object.assign({}, dataEventSchedule));
  }
};
export default mutations;
